import { createContext, useContext, useEffect, useMemo, useState } from "react";

const AmbienteMedicaoContext = createContext( undefined );

const STORAGE_KEY = "medicao:ambiente";

export function AmbienteProvider({ children }){

    const [ ambiente, setAmbiente ] = useState( null );

    useEffect(() => {

        const raw = sessionStorage.getItem( STORAGE_KEY );
        if( raw ) setAmbiente( JSON.parse( raw ) ); 

    }, [])

    useEffect(() => {

        if( ambiente ) sessionStorage.setItem( STORAGE_KEY, JSON.stringify(ambiente) );
        else sessionStorage.removeItem( STORAGE_KEY );

    }, [ ambiente ])

    const value = useMemo(() => ({ ambiente, setAmbiente }), [ ambiente ]);

    return(
        <AmbienteMedicaoContext.Provider value={ value }>
            { children }
        </AmbienteMedicaoContext.Provider>
    )

}

export function useAmbienteMedicao(){

    const ctx = useContext( AmbienteMedicaoContext );
    if( !ctx ) throw new Error("useAmbienteMedicao deve ser usado dentro de um AmbienteProvider");
    return ctx;

}